module.exports = __webpack_public_path__ + "static/media/Leona.d9ef7ebd.png";